import React from "react";
import { Sun, Moon, Translate, MagnifyingGlass, List } from "@phosphor-icons/react";
import { useTheme } from "@/contexts/ThemeContext";
import { useLang } from "@/contexts/LanguageContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import NotificationBell from "@/components/NotificationBell";

export default function Topbar({ title, subtitle, actions }) {
  const { theme, toggle } = useTheme();
  const { lang, toggle: toggleLang } = useLang();

  return (
    <div
      data-testid="app-topbar"
      className="sticky top-0 z-10 bg-background/85 backdrop-blur-xl shrink-0"
    >
      <div className="flex items-start md:items-center justify-between gap-3 md:gap-6 px-4 py-4 md:px-8 md:py-6">
        <Button variant="ghost" size="icon" className="md:hidden -ml-1 shrink-0" onClick={() => window.dispatchEvent(new Event("sdm:toggle-menu"))} data-testid="mobile-menu-toggle" aria-label="Menú">
          <List size={22} />
        </Button>
        <div className="min-w-0 flex-1">
          <div className="overline mb-1.5 hidden md:block">
            SDM Customer Engagement Console
          </div>
          <h1 className="font-heading text-2xl md:text-3xl font-extrabold tracking-[-0.035em] leading-tight" data-testid="page-title">
            {title}
          </h1>
          {subtitle && <p className="text-xs md:text-sm text-muted-foreground mt-1 max-w-2xl">{subtitle}</p>}
        </div>
        <div className="flex items-center gap-0.5 md:gap-2 shrink-0 flex-wrap justify-end">
          <div className="relative hidden md:block">
            <MagnifyingGlass size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <Input
              className="pl-11 pr-4 w-64 h-11 bg-input border-0 rounded-xl"
              placeholder={lang === "es" ? "Buscar…" : "Search…"}
              data-testid="topbar-search"
            />
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={toggleLang}
            data-testid="lang-toggle"
            title={lang === "es" ? "English" : "Español"}
            className="gap-1 rounded-full"
          >
            <Translate size={16} />
            <span className="text-xs uppercase font-semibold">{lang}</span>
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={toggle}
            data-testid="theme-toggle"
            title={theme === "dark" ? "Light" : "Dark"}
            className="rounded-full"
          >
            {theme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
          </Button>
          <NotificationBell />
          {actions}
        </div>
      </div>
    </div>
  );
}
